import {Base} from "@/api/Base"

export class DepartmentListAll extends Base {
    path = "department/listAll"
}